import { createStore } from 'vuex';

// modules
import facilities from './facilities';

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation
 */

const vuexStore = createStore({
    modules: {
        facilities
    },
    actions: {
        /**
         * Reset states for all store modules.
         * Note: When all states are reset, JWT and User data is also cleared from the local storage.
         *       For iPad users, the tenant information is also stored in the local storage, but on
         *       reset, the tenant information is not cleared to make it convenient for tenants to
         *       switch users on the same tablet.
         */
        resetAllStates({ dispatch }) {
            dispatch('facilities/resetState');
        }
    },

    // enable strict mode (adds overhead!)
    // for dev mode only
    // @ts-ignore
    strict: process.env.DEV
});

export default vuexStore;
